import React from 'react';
import './App.css';

function App() {
  const handleEmailClick = () => {
    const email = 'info@nexapromos.com';
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Privacy Policy
          </h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
            <p>
              This Privacy Policy governs the manner in which Nexa Nova Media LLC (“Company,” “we,” “us,” or “our”) collects, uses, maintains, and discloses information collected from users (“User” or “you”).
</p>
<p>
This Privacy Policy applies to all websites, landing pages, digital properties, and online services operated or controlled by Nexa Nova Media LLC, including but not limited to promotional websites, affiliate websites, marketing funnels, and related online offerings (collectively, the “Sites”).
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Personal identification information
            </h2>
            <p>
              We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, subscribe to the newsletter, fill out a form, and in connection with other activities, services, features or resources we make available on our Site. Users may be asked for, as appropriate, name, email address. Users may, however, visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Non-personal identification information
            </h2>
            <p>
              We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Web browser cookies
            </h2>
            <p>
              Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              How we use collected information
            </h2>
            <p>
              The Site may collect and use Users personal information for the following purposes:
            </p>
            <ul className="list-disc ml-6 space-y-2">
              <li><strong>To improve our Site</strong> We may use feedback you provide to improve our products and services.</li>
              <li><strong>To run a promotion, contest, survey or other Site feature</strong> To send Users information they agreed to receive about topics we think will be of interest to them.</li>
              <li><strong>To send periodic emails</strong> We may use the email address to send User information and updates pertaining to their order. It may also be used to respond to their inquiries, questions, and/or other requests. If User decides to opt-in to our mailing list, they will receive emails that may include company news, updates, related product or service information, etc. If at any time the User would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              How we protect your information
            </h2>
            <p>
              We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
            </p>
            <p>
              Sensitive and private data exchange between the Site and its Users happens over a SSL secured communication channel and is encrypted and protected with digital signatures.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Sharing your personal information
            </h2>
            <p>
              We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Third party websites
            </h2>
            <p>
              Users may find advertising or other content on our Site that link to the sites and services of our partners, suppliers, advertisers, sponsors, licensors and other third parties. We do not control the content or links that appear on these sites and are not responsible for the practices employed by websites linked to or from our Site. In addition, these sites or services, including their content and links, may be constantly changing. These sites and services may have their own privacy policies and customer service policies. Browsing and interaction on any other website, including websites which have a link to our Site, is subject to that website's own terms and policies.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Advertising
            </h2>
            <p>
              Ads appearing on our site may be delivered to Users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile non personal identification information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This privacy policy does not cover the use of cookies by any advertisers.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Compliance with children's online privacy protection act
            </h2>
            <p>
              Protecting the privacy of the very young is especially important. For that reason, we never collect or maintain information at our Site from those we actually know are under 13, and no part of our website is structured to attract anyone under 13.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Changes to this privacy policy
            </h2>
            <p>
              The Site has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Your acceptance of these terms
            </h2>
            <p>
              By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
              Contacting us
            </h2>
            <p>
              If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at{' '}
              <button
                onClick={handleEmailClick}
                className="text-blue-600 hover:text-blue-800 underline cursor-pointer bg-transparent border-none p-0 font-inherit"
                aria-label="Contact us via email"
              >
                info [at] nexapromos [dot] com
              </button>
            </p>

            <div className="mt-12 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                This document was last updated on January 24, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;